import React, { useEffect } from 'react';
import AboutText from '../components/AboutComponents/AboutText';
import TextContentHeader from '../components/TextContent/TextContentHeader';
import ServicesDetailedheader from '../components/ServicesComponents/ServicesDetailedheader';
import CallToAction from '../components/Misc/CallToAction';
import Art from '../components/Misc/Art';
import TabsSection from '../components/Sections/TabsSection';
import Seo from '../components/Misc/Seo';
import illustration from '../assets/images/art_2.png';

import logo from '../assets/images/logo.png';
import servicesHeaderImage from '../assets/images/services-header.webp';
import servicesFooterImage from '../assets/images/services-footer_grey.webp';

function Services() {
    const canonical = 'https://studio.norcat.org/Services';
    const title = 'Services at Studio NORCAT | A Studio driven by experiences that matter.';
    const description =
        'Explore Studio NORCAT services across VR, AR, software, simulation, and interactive installations designed for learning, training, and real-world engagement.';

    useEffect(() => {
        document.body.classList.add('services-page-view');

        return () => {
            document.body.classList.remove('services-page-view');
        };
    }, []);

    return (
        <div className="services-page">
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${servicesHeaderImage}`}
                ogImageAlt="A Studio NORCAT team member performs scaling in the Motion Capture Volume"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${servicesHeaderImage}`}
                twitterImageAlt="A Studio NORCAT team member performs scaling in the Motion Capture Volume"
            />
            <ServicesDetailedheader />
            <AboutText
                image={logo}
                content="We don't follow a fixed process. Each project guides how we work, helping us stay focused on what needs to be built while adapting as we go."
            />

            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <TextContentHeader heading="Capabilities built through experience." />

                    <div className="text-content-inner">
                        <TabsSection dark="true" />
                    </div>
                    <CallToAction
                        wrapperClass="text-content-footer bg-black pt-0 pb-0"
                        headingClass="light-1"
                        heading={
                            <>
                                Have an idea?
                                <br />
                                Let&apos;s explore it together.
                            </>
                        }
                        buttonText="Contact Us"
                        buttonLink="/Contact"
                        buttonType="1"
                    />
                    <Art art={illustration} type="2" />
                </div>
            </div>

            <div className="single-image ">
                <img src={servicesFooterImage} alt="A view of the Studio NORCAT team and office" loading="lazy" decoding="async" />
            </div>
        </div>
    );
}

export default Services;
